import { animate, motion, useMotionValue, useTransform } from 'motion/react'
import { useEffect, useRef } from 'react'

interface AnimatedNumberProps {
  value: number
  prefix?: string
  suffix?: string
  decimals?: number
  useLocale?: boolean
  duration?: number
}

export function AnimatedNumber({
  value,
  prefix = '',
  suffix = '',
  decimals = 0,
  useLocale = false,
  duration = 0.8,
}: AnimatedNumberProps) {
  const motionValue = useMotionValue(0)
  const isFirstRender = useRef(true)

  const displayed = useTransform(motionValue, (latest) => {
    const formatted = useLocale
      ? latest.toLocaleString(undefined, {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
        })
      : decimals > 0
        ? latest.toFixed(decimals)
        : Math.round(latest).toString()
    return `${prefix}${formatted}${suffix}`
  })

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      animate(motionValue, value, { duration, ease: 'easeOut' })
    } else {
      animate(motionValue, value, { duration: duration * 0.6, ease: 'easeOut' })
    }
  }, [value, motionValue, duration])

  return <motion.span>{displayed}</motion.span>
}
